import { render } from "./DemoWhatsAppView.vue?vue&type=template&id=987a7662&scoped=true"
import script from "./DemoWhatsAppView.vue?vue&type=script&lang=js"
export * from "./DemoWhatsAppView.vue?vue&type=script&lang=js"

import "./DemoWhatsAppView.vue?vue&type=style&index=0&id=987a7662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987a7662"]])

export default __exports__